/**
 * Реквизиты ООО «РИЧ ЧАТ» и контакты.
 *
 * LEGAL-OOO (2026): с переходом приёма платежей на ООО «РИЧ ЧАТ» роль
 * Лицензиата (ИП Зайцев В.И.) упразднена. Одно лицо является
 * правообладателем ПО, стороной Пользовательского соглашения, получателем
 * платежей и оператором персональных данных.
 *
 * Используется на странице реквизитов, в подвале документов, в шапке
 * соглашения и политики. Хранится здесь чтобы:
 *  - при изменении (новые расчётные счета, email и т.п.) править в одном месте;
 *  - страницы Пользовательское соглашение / Политика конфиденциальности /
 *    Реквизиты были автоматически согласованы между собой.
 */

export const COMPANY = {
  // ООО «РИЧ ЧАТ» — правообладатель ПО, сторона Соглашения,
  // получатель платежей, оператор персональных данных.
  fullName: 'Общество с ограниченной ответственностью «РИЧ ЧАТ»',
  shortName: 'ООО «РИЧ ЧАТ»',
  inn: '6312225667',
  kpp: '631201001',
  ogrn: '1266300013660',
  address: '443029, Самарская область, г. Самара, пр-ка 7-Я, д. 108, кв. 130',
  bankAccount: '40702810020000334713',
  bankName: 'ООО «Банк Точка»',
  bik: '044525104',
  corrAccount: '30101810745374525104',
  email: 'noreply@richat.ru',
} as const;

/**
 * Обратная совместимость: RIGHTHOLDER исторически использовался в шапке
 * политики и соглашения. Теперь это то же самое лицо, что и COMPANY.
 * Новый код должен использовать COMPANY.
 */
export const RIGHTHOLDER = COMPANY;

export const CONTACTS = {
  // Контакты для сбыта и поддержки
  salesTelegram: 'https://t.me/RiChat_sales',
  salesTelegramLabel: '@RiChat_sales',
  supportEmail: 'noreply@richat.ru',
} as const;

export const DOC_DATES = {
  // Дата публикации действующих редакций документов.
  // LEGAL-OOO: проставляется в день наката пакета на прод (см. runbook).
  privacyLastUpdated: '24 августа 2026 г.',
  termsLastUpdated: '24 августа 2026 г.',
} as const;

export const SERVICE = {
  // Сведения о Сервисе
  name: 'RiChat',
  fullName: 'Интегратор нейросетей RiChat',
  registryRecord: '№30516 от 06.11.2025',
  registryName: 'единый реестр российских программ для ЭВМ и баз данных',
  publicSite: 'https://richat.ru/',
  cabinetSite: 'https://cabinet.richat.ru/',
} as const;
